<anon-headline>
  <ng-container header>Let's build the future of the web, together</ng-container>
  <ng-container subheader>The best part about technology is seeing what the world does with it.</ng-container>
  <ng-container buttons>
<!--    <button mat-raised-button color="accent" [routerLink]="nav_path.stories">See all stories</button>-->
  </ng-container>
</anon-headline>

<section class="home-buttons">
  <div class="card">
    <h2>Featured Projects</h2>
    <p>Explore our featured projects to discover what we've been working on.</p>
    <button mat-raised-button color="primary" [routerLink]="nav_path.portfolio">Explore</button>
  </div>

  <div class="card">
    <h2>Featured Stories</h2>
    <p>View our featured stories to discover something new.</p>
    <button mat-raised-button color="primary" [routerLink]="nav_path.stories" [queryParams]="{featured: true}">View</button>
  </div>

<!--  <div class="card">-->
<!--    <h2>Story Categories</h2>-->
<!--    <p>Browse stories by the topic of your choice.</p>-->
<!--    <button mat-raised-button color="primary">View</button>-->
<!--  </div>-->

<!--  <div class="card">-->
<!--    <h2>Story Tags</h2>-->
<!--    <p>Find similar stories that contain the tag of your choice.</p>-->
<!--    <button mat-raised-button color="primary">View</button>-->
<!--  </div>-->
</section>
